import React from 'react'
import styled from 'styled-components'

export const SummaryCell = ({ summary, date }) => {
  // const isWeekEnd = date.day() === 0 || date.day() === 6
  return (
    <Cell style={ { flex: 1, overflow: 'hidden', backgroundColor: '#F7F7F7', display: 'flex', alignItems: 'center', justifyContent: 'center' } }>
      {summary && summary.map[date.format('YYYY-MM-DD')] && summary.map[date.format('YYYY-MM-DD')].content}
      {summary && !summary.map[date.format('YYYY-MM-DD')] && summary.default}
    </Cell>
  )
}

const Cell = styled.div`
  border: solid #EAEAEA;
  border-width: 0px 1px 0px 0px;
`



// WEBPACK FOOTER //
// ./src/components/calendar/vertical-table/summary-cell.js